import styled from 'styled-components';
import { Icon } from '../icon';

// Type and icon size come from the box, which owns the size scale — these only
// say how the pieces share the row.
export const DropdownValueIcon = styled(Icon)`
  flex: 0 1 auto;
`;

export const DropdownValue = styled.span`
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const DropdownPlaceholder = styled.span`
  color: ${props => props.theme.form.dropdown.box.placeholder};
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const DropdownTextInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  padding: 0;
  box-sizing: border-box;
  // Inputs default to a white background, black text and their own type — all
  // three wrong on the box, and font is not inherited by form controls.
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;

  &::placeholder {
    color: ${props => props.theme.form.dropdown.box.placeholder};
    opacity: 1;
  }
`;

export const DropdownSearchIcon = styled(Icon)`
  flex: 0 1 auto;
`;
